export const ANSWER_ASSESSMENT_QUESTION = 'ANSWER_ASSESSMENT_QUESTION' as const
export const INIT_ASSESSMENT_ANSWERS = 'INIT_ASSESSMENT_ANSWERS' as const
export const RESET_ASSESSMENT_ANSWERS = 'RESET_ASSESSMENT_ANSWERS' as const
export const LOAD_ASSESSMENT_DETAILS_PAGE_DATA = 'LOAD_ASSESSMENT_DETAILS_PAGE_DATA' as const

export interface AssessmentQuestion {
  id: string
  question_type?: string
  title?: string
  scenario_content?: string
  assessment_choices?: Array<{ id: string; title: string; assessment_question_id?: string }>
}

export interface AssessmentChoice {
  id: string
  title: string
  choice_id?: string
  explanation_content?: string
}

export function answerQuestion(question: AssessmentQuestion, choiceId: string) {
  return {
    type: ANSWER_ASSESSMENT_QUESTION,
    payload: {
      question,
      choiceId,
    },
  }
}

export function initAnswers(questions: AssessmentQuestion[]) {
  return {
    type: INIT_ASSESSMENT_ANSWERS,
    payload: {
      questions,
    },
  }
}

export function resetAnswers() {
  return {
    type: RESET_ASSESSMENT_ANSWERS,
  }
}

export function loadAssessmentPageData({
  assessmentSlug,
  req,
}: {
  assessmentSlug: string
  req?: unknown
}) {
  return {
    type: LOAD_ASSESSMENT_DETAILS_PAGE_DATA,
    payload: { assessmentSlug, req },
  }
}
